import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {X_HOLE_ANIMATIONS} from "../server/IKMDData";

export class KMDXHOverlayAnimations extends PIXI.Container implements StageLayer {

    private _suck: PIXI.spine.Spine;
    private _suckClose: PIXI.spine.Spine;
    private _blast: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "KMDXHOverlayAnimations";

        this.init();
    }

    public playSuck(): gsap.core.Timeline {
        return (KennethMustDie.createTimelineForAnimation(this._suck, 0, X_HOLE_ANIMATIONS.SUCK_OVERLAY, false).eventCallback("onStart", () => {
            this._suck.visible = true;
        }).eventCallback("onComplete", () => {
            this._suck.visible = false;
        }));
    }

    public playSuckClose(): gsap.core.Timeline {
        return (KennethMustDie.createTimelineForAnimation(this._suckClose, 0, X_HOLE_ANIMATIONS.SUCK_CLOSE, false).eventCallback("onStart", () => {
            this._suckClose.visible = true;
        }).eventCallback("onComplete", () => {
            this._suckClose.visible = false;
        }));
    }

    public playBlast(level: number): gsap.core.Timeline {
        return (KennethMustDie.createTimelineForAnimation(this._blast, 0, X_HOLE_ANIMATIONS.BLAST + level, false).eventCallback("onStart", () => {
            this._blast.visible = true;
        }).eventCallback("onComplete", () => {
            this._blast.visible = false;
        }));
    }

    private init(): void {
        this._suck = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("suckOverlay"));
        this._suck.visible = false;
        this._suck.position.set(366, 325);

        this._suckClose = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("suckClose"));
        this._suckClose.visible = false;
        this._suckClose.position.set(360, 310);

        this._blast = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("xHoleBlast"));
        this._blast.visible = false;
        this._blast.position.set(360, 310);

        this.addChild(this._suck, this._suckClose, this._blast);
    }
}